import Axios from "axios";
import React from "react";
import { baseUrl } from "../assets/Animations";
import MonthViewCalendar from "./MonthViewCalendar/MonthViewCalendar";
import NewCalendarEvent from "./NewCalendarEvent/NewCalendarEvent";
import WeekViewCalendar from "./WeekViewCalendar/WeekViewCalendar";
import "./calendar.css";

import {
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  parse,
  startOfToday,
  startOfWeek,
} from "date-fns";
import SuccessfullySavedPopup from "../SuccessfullySavedPopup/SuccessfullySavedPopup";
import CalendarEvent from "./CalendarEvent/CalendarEvent";
import CalendarLoadingCover from "./CalendarLoadingCover/CalendarLoadingCover";
import ChangeFollowingEventsPopup from "./ChangeFollowingEventsPopup/ChangeFollowingEventsPopup";
import DayViewCalendar from "./DayViewCalendar/DayViewCalendar";
import DeleteFollowingEventsPopup from "./DeleteFollowingEventsPopup/DeleteFollowingEventsPopup";
import FamilySearchPopup from "./FamilySearchPopup/FamilySearchPopup";
import NewPendingOffer from "./NewPendingOffer/NewPendingOffer";
import TeacherListForCalendar from "./TeacherListForCalendar/TeacherListForCalendar";
import TopBarCalendar from "./TopBarCalendar/TopBarCalendar";
import UnsavedCalendarEventPopup from "./UnsavedCalendarEventPopup/UnsavedCalendarEventPopup";
import {
  convertStringToUTCString,
  createAndOrganizeAllCalendarEventsForDisplayedPeriodOfTime,
  deleteAllEvents,
  deleteSoloEvent,
  deleteThisAndFollowEvents,
  deleteThisEvent,
  editAllEvents,
  editSoloEvent,
  editSoloEventAfterOfferChange,
  editThisAndFollowingEvents,
  editThisEvent,
  filterOutPendingOffersAndUpdateEvent,
  findDuplicateCalendarEvent,
  generateNewCalendarEvent,
  generateNewPendingOffer,
} from "./calendarFunctions";
import { getRequestHeaders } from "../api";

const Calendar = ({ userData, socket }) => {
  const [selectedDay, setSelectedDay] = React.useState({
    date: startOfToday(),
    events: [],
    availabilities: [],
  });
  const [currentMonth, setCurrentMonth] = React.useState(
    format(startOfToday(), "MMMM yyyy")
  );
  const [allEvents, setAllEvents] = React.useState([]);
  const [view, setView] = React.useState("Month view");
  const [teachers, setTeachers] = React.useState([]);
  const [selectedTeacherIds, setSelectedTeacherIds] = React.useState([]);
  const [showExTeachers, setShowExTeachers] = React.useState(false);
  const [teachersToDisplayObject, setTeachersToDisplayObject] = React.useState(
    {}
  );
  const [loadingTeachers, setLoadingTeachers] = React.useState(true);
  const [loadingTeacherEvents, setLoadingTeacherEvents] = React.useState(false);
  const [openEvent, setOpenEvent] = React.useState(false);
  const [openOffer, setOpenOffer] = React.useState(false);
  const [newOfferObject, setNewOfferObject] = React.useState(false);
  const [editEventToggle, setEditEventToggle] = React.useState(false);
  const [eventObjectToEdit, setEventObjectToEdit] = React.useState(false);
  const [editedEventObjectsOriginalDate, setEditedEventObjectsOriginalDate] =
    React.useState(false);
  const [schoolCalendar, setSchoolCalendar] = React.useState(false);
  const [schoolFamilies, setSchoolFamilies] = React.useState([]);
  const [newEvent, setNewEvent] = React.useState(false);
  const [familySearchOpen, setFamilySearchOpen] = React.useState(false);
  const [daysOfTheDisplayedMonth, setDaysOfTheDisplayedMonth] = React.useState(
    eachDayOfInterval({
      start: startOfWeek(parse(currentMonth, "MMMM yyyy", new Date())),
      end: endOfWeek(endOfMonth(parse(currentMonth, "MMMM yyyy", new Date()))),
    })
  );
  const [calendarDaysWithEvents, setCalendarDaysWithEvents] = React.useState(
    {}
  );
  const [changeFollowingEvents, setChangeFollowingEvents] =
    React.useState(false);
    const [isItTheOriginalEvent, setIsItTheOriginalEvent] = React.useState(false);
  const [deleteFollowingEvents, setDeleteFollowingEvents] =
    React.useState(false);
  const [discardUnsavedChangesPopup, setDiscardUnsavedChangesPopup] =
    React.useState(false);
  const [discardType, setDiscardType] = React.useState("");
  const [successfullySaved, setSuccessfullySaved] = React.useState(false);
  const [offerStatusChanged, setOfferStatusChanged] = React.useState(false);
  const [loadingCover, setLoadingCover] = React.useState(false);
  const [newEventSaveError, setNewEventSaveError] = React.useState("");
  const [tempEmailData, setTempEmailData] = React.useState([]);
  const activeTeacherListCacheRef = React.useRef({});
  const fullTeacherListCacheRef = React.useRef({});

  const myToken = localStorage.getItem("token");
  const myHeader = { headers: { Authorization: `Bearer ${myToken}` } };
  const extractTeacherList = React.useCallback((payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.teachers)) return payload.teachers;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
  }, []);

  const eventBelongsToSelectedTeacher = React.useCallback(
    (event) => {
      if (!selectedTeacherIds.length || !event) return false;
      const teacherId =
        event.teacherId || event.teacherID || event.TeacherID || event.teacher;
      return selectedTeacherIds.includes(String(teacherId || ""));
    },
    [selectedTeacherIds]
  );

  const getSelectedTeacherCalendarEvents = React.useCallback(
    (teacherIds = selectedTeacherIds) => {
      const normalizedTeacherIds = Array.isArray(teacherIds)
        ? teacherIds.filter(Boolean).map((id) => String(id))
        : [];
      if (!normalizedTeacherIds.length) {
        setAllEvents([]);
        setCalendarDaysWithEvents({});
        return Promise.resolve([]);
      }
      setLoadingTeacherEvents(true);
      return Promise.all(
        normalizedTeacherIds.map((teacherId) =>
          Axios.get(`${baseUrl}/calendar/teacher/${teacherId}`, getRequestHeaders())
            .then((res) => (Array.isArray(res.data) ? res.data : []))
            .catch((err) => {
              console.log(err);
              return [];
            })
        )
      )
        .then((responses) => {
          const mergedEvents = responses
            .flat()
            .sort((a, b) => (a.dateTime > b.dateTime ? 1 : -1));
          setAllEvents([...mergedEvents]);
          return mergedEvents;
        })
        .catch((err) => {
          console.log(err);
          setAllEvents([]);
          return [];
        })
        .finally(() => {
          setLoadingTeacherEvents(false);
        });
    },
    [selectedTeacherIds]
  );

  React.useEffect(() => {
    const handleSocketConnection = () => {
      if (document.visibilityState === "visible") {
        if(schoolCalendar && selectedTeacherIds.length) {
          getSelectedTeacherCalendarEvents(selectedTeacherIds);
        }
      }
    };

    window.addEventListener("visibilitychange", handleSocketConnection);

    return () => {
      window.removeEventListener("visibilitychange", handleSocketConnection);
    };
  }, [schoolCalendar, selectedTeacherIds, getSelectedTeacherCalendarEvents]);

  React.useEffect(() => {

    editEventToggle
      ? setEditedEventObjectsOriginalDate(eventObjectToEdit.dateTime)
      : setEditedEventObjectsOriginalDate(false);
    editEventToggle &&
      socket.emit("openCalendarEvent", {
        emitter: userData.Name,
        packet: eventObjectToEdit,
      });
  }, [editEventToggle]);


  React.useEffect(() => {
    setDaysOfTheDisplayedMonth(
      eachDayOfInterval({
        start: startOfWeek(parse(currentMonth, "MMMM yyyy", new Date())),
        end: endOfWeek(
          endOfMonth(parse(currentMonth, "MMMM yyyy", new Date()))
        ),
      })
    );
  }, [currentMonth]);

  React.useEffect(() => {
    if (schoolCalendar) {
      setShowExTeachers(false);
      setSelectedTeacherIds([]);
      setAllEvents([]);
      setCalendarDaysWithEvents({});
      setTeachersToDisplayObject({});
    }
  }, [schoolCalendar]);

  React.useEffect(() => {
    if (!schoolCalendar) {
      return;
    }

    const schoolKey = schoolCalendar.schoolAbbreviation.toLowerCase();
    const cacheRef = showExTeachers ? fullTeacherListCacheRef : activeTeacherListCacheRef;

    setLoadingTeachers(true);

    if (cacheRef.current[schoolKey]) {
      const cachedTeachers = cacheRef.current[schoolKey];
      setTeachers(sortAndTurnOnAllTeachers(cachedTeachers, selectedTeacherIds));
      setLoadingTeachers(false);
      return;
    }

    const endpoint = showExTeachers
      ? `${baseUrl}/teachersbyschool/${schoolKey}`
      : `${baseUrl}/calendar/teachers/${schoolKey}`;

    Axios.get(endpoint, getRequestHeaders())
      .then((res) => {
        const teacherList = extractTeacherList(res?.data);
        cacheRef.current[schoolKey] = teacherList;
        setTeachers(sortAndTurnOnAllTeachers(teacherList, selectedTeacherIds));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingTeachers(false);
      });
  }, [schoolCalendar, showExTeachers, extractTeacherList]);

  React.useEffect(() => {
    if (!schoolCalendar || !selectedTeacherIds.length) {
      setAllEvents([]);
      setCalendarDaysWithEvents({});
      return;
    }
    getSelectedTeacherCalendarEvents(selectedTeacherIds);
  }, [schoolCalendar, selectedTeacherIds, getSelectedTeacherCalendarEvents]);

  React.useEffect(() => {
    if (!schoolCalendar || !selectedTeacherIds.length) {
      setCalendarDaysWithEvents({});
      return;
    }
    createAndOrganizeAllCalendarEventsForDisplayedPeriodOfTime(
      daysOfTheDisplayedMonth,
      teachers,
      allEvents,
      teachersToDisplayObject,
      setCalendarDaysWithEvents,
      schoolCalendar.timeZone
    );
  }, [
    daysOfTheDisplayedMonth,
    allEvents,
    teachersToDisplayObject,
    teachers,
    selectedDay,
    schoolCalendar,
    selectedTeacherIds
  ]);

  React.useEffect(() => {
    socket.on("createCalendarEvent", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet)) {
        setAllEvents((prev) => [...prev, data.packet]);
      }
    });
    socket.on("openCalendarEvent", (data) => {
      if (data.emitter !== userData.Name) {
        //console.log("they open dawg");

        //DO SOMETHING HERE WHEN SOMEONE ELSE IS EDITING A CALENDAR EVENT
      }
    });
    socket.on("closeAndSaveCalendarEvent-solo-events", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet?.response)) {
        data.option === 1
          ? setAllEvents((prev) => [
              ...prev.map((e) =>
                e.id === data.packet.response.id ? data.packet.response : e
              ),
            ])
          : setAllEvents((prev) =>
              filterOutPendingOffersAndUpdateEvent(prev, data.packet.response)
            );
      }
    });
    socket.on("closeAndSaveCalendarEvent-all-events", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet)) {
        setAllEvents((prev) =>
          prev.map((e) => (e.id === data.packet.id ? data.packet : e))
        );
      }
    });
    socket.on("closeAndSaveCalendarEvent-following-events", (data) => {
      if (data.emitter !== userData.Name) {
        if (data.option === 1 && eventBelongsToSelectedTeacher(data.response?.[1]?.data)) {
          setAllEvents((prev) => {
            // Add the new event and remove the old one
            const updatedEvents = prev.filter((e) => e.id !== data.response[0].data.id);
            updatedEvents.push(data.response[1].data);
            return updatedEvents;
          });
        } else if (data.option === 2 && eventBelongsToSelectedTeacher(data.response?.[0]?.data)) {
          setAllEvents((prev) => {
            // Update the existing event
            const updatedEvents = prev.map((e) =>
              e.id === data.response[0].data.id ? data.response[0].data : e
            );
            // Add the new event
            updatedEvents.push(data.response[1].data);
            return updatedEvents;
          });
        }
      }
    });
    socket.on("closeAndSaveCalendarEvent-this-event", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet?.[0]?.data)) {
        setAllEvents((prev) => [
          ...prev.map((e) =>
            e.id === data.packet[0].data.id ? data.packet[0].data : e
          ),
        ]);
        setAllEvents((prev) => [...prev, data.packet[1].data]);
      }
    });
    socket.on("closeAndDeleteCalendarEvent", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet)) {
        setAllEvents((prev) => [
          ...prev.filter((e) => e.id !== data.packet.id),
        ]);
      }
    });
    socket.on("closeAndDeleteCalendarEvent-following-events", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet?.response)) {
        data.packet.option === 1
          ? setAllEvents((prev) => [
              ...prev.filter(
                (e) => e.lessonId !== data.packet.response.lessonId
              ),
            ])
          : setAllEvents((prev) => [
              ...prev.map((e) =>
                e.id === data.packet.response.id ? data.packet.response : e
              ),
            ]);
      }
    });
    socket.on("closeAndDeleteCalendarEvent-this-event", (data) => {
      if (data.emitter !== userData.Name && eventBelongsToSelectedTeacher(data.packet?.response)) {
        data.packet.option === 1
          ? setAllEvents((prev) => [
              ...prev.map((e) =>
                e.id === data.packet.response.id ? data.packet.response : e
              ),
            ])
          : setAllEvents((prev) => [
              ...prev.filter((e) => e.id !== data.packet.response.id),
            ]);
      }
    });
  }, [socket, userData.Name, eventBelongsToSelectedTeacher]);

  const createCalendarEvent = async (localEvent) => {
    setLoadingCover(true);
    setNewEventSaveError("");
    let event = {
      ...localEvent,
      teacherName: String(localEvent.teacherName || "").trim(),
      dateTime: convertStringToUTCString(
        localEvent.dateTime,
        schoolCalendar.timeZone
      ),
    };
    try {
      const teacherId = String(event.teacherId || "").trim();
      let latestTeacherEvents = allEvents;
      if (teacherId) {
        try {
          const response = await Axios.get(
            `${baseUrl}/calendar/teacher/${teacherId}`,
            getRequestHeaders()
          );
          if (Array.isArray(response.data)) latestTeacherEvents = response.data;
        } catch (refreshError) {
          console.log(refreshError);
        }
      }

      if (findDuplicateCalendarEvent(event, latestTeacherEvents)) {
        setNewEventSaveError(
          "This exact lesson is already on the teacher's calendar. No duplicate was created."
        );
        setLoadingCover(false);
        return;
      }

      const res = await Axios.post(
        `${baseUrl}/calendar`,
        { event },
        getRequestHeaders()
      );
      setOpenEvent(false);
      setOpenOffer(false);
      socket.emit("createCalendarEvent", {
        emitter: userData.Name,
        packet: res.data,
      });
      if (eventBelongsToSelectedTeacher(res.data)) {
        setAllEvents((previousEvents) => [...previousEvents, res.data]);
      }
      setSuccessfullySaved(true);
      setLoadingCover(false);
    } catch (err) {
      console.log(err);
      if (err?.response?.status === 409) {
        setNewEventSaveError(
          err.response?.data?.message
            || "This exact lesson is already on the teacher's calendar."
        );
      }
      setLoadingCover(false);
    }
  };

  const editTheEvent = async (kind) => {
    setLoadingCover(true);
    if (kind === "all-events") {
      await editAllEvents(
        eventObjectToEdit,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name
      );
    } else if (kind === "following-events") {
      await editThisAndFollowingEvents(
        eventObjectToEdit,
        editedEventObjectsOriginalDate,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name,
        myHeader
      );
    } else if (kind === "this-event") {
      await editThisEvent(
        eventObjectToEdit,
        editedEventObjectsOriginalDate,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name,
        myHeader
      );
    }
    setChangeFollowingEvents(false);
    setTimeout(() => {
      setLoadingCover(false);
    }, 100);
  };

  const closeAndEditSoloEvent = async () => {
    if (offerStatusChanged && !eventObjectToEdit.isPendingOffer) {
      await editSoloEventAfterOfferChange(
        eventObjectToEdit,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name
      );
    } else {
      await editSoloEvent(
        eventObjectToEdit,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name
      );
    }
  };

  const closeAndDeleteSoloEvent = async () => {
    await deleteSoloEvent(
      eventObjectToEdit,
      setAllEvents,
      setEditEventToggle,
      socket,
      userData.Name
    );
  };

  const deleteTheEvent = async (kind) => {
    if (kind === "all-events") {
      await deleteAllEvents(
        eventObjectToEdit,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name
      );
    } else if (kind === "following-events") {
      await deleteThisAndFollowEvents(
        eventObjectToEdit,
        editedEventObjectsOriginalDate,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name
      );
    } else if (kind === "this-event") {
      await deleteThisEvent(
        eventObjectToEdit,
        editedEventObjectsOriginalDate,
        setAllEvents,
        setEditEventToggle,
        socket,
        userData.Name,
        myHeader
      );
    }
    setDeleteFollowingEvents(false);
  };

  const sortAndTurnOnAllTeachers = (t, selectedIds = selectedTeacherIds) => {
    const teacherList = Array.isArray(t)
      ? [...t]
      : Array.isArray(t?.teachers)
        ? [...t.teachers]
        : [];
    const normalizedSelectedIds = (selectedIds || []).map((id) => String(id));
    let primingObject = {};
    teacherList.sort((a, b) =>
      String(a?.Name || a?.name || '').localeCompare(String(b?.Name || b?.name || ''))
    );
    teacherList.forEach((teacher) => {
      const teacherName = teacher?.Name || teacher?.name || teacher?.teacherName || '';
      const teacherId = teacher?.TeacherID || teacher?.teacherId || teacher?.teacherID || teacher?.id || '';
      const teacherStatus = teacher?.Status || teacher?.status || '';
      const teacherSchool = teacher?.School || teacher?.school || '';
      const teacherColor = teacher?.CalendarColor || teacher?.calendarColor || null;

      if (!teacherName || !teacherId) {
        return;
      }

      primingObject[teacherName] = {
        TeacherID: teacherId,
        School: teacherSchool,
        Availability: teacher.AvailabilityDetails,
        WantsMoreStudents: teacher.WantsMoreStudents,
        Status: teacherStatus,
        ShowTeacherInList: showExTeachers ? true : teacherStatus !== 'Left School',
        displayed: normalizedSelectedIds.includes(String(teacherId)),
        color: teacherColor
          ? teacherColor
          : {
              name: "Blue",
              bgColor: "bg-blue-800",
              selectedColor: "ring-blue-800",
            },
        };
      });
    const visibleTeacherIds = teacherList
      .map((teacher) => String(teacher?.TeacherID || teacher?.teacherId || teacher?.teacherID || teacher?.id || ''))
      .filter(Boolean);
    const nextSelectedTeacherIds = normalizedSelectedIds.filter((id) => visibleTeacherIds.includes(id));
    if (nextSelectedTeacherIds.length !== normalizedSelectedIds.length) {
      setSelectedTeacherIds(nextSelectedTeacherIds);
    }
    setTeachersToDisplayObject(primingObject);
    return teacherList;
  };

  const unselectAllTeachers = () => {
    let primingObject = {};
    Object.keys(teachersToDisplayObject).forEach((teacher) => {
      primingObject[teacher] = {
        ...teachersToDisplayObject[teacher],
        displayed: false,
      };
    });
    setTeachersToDisplayObject(primingObject);
  };

  const handleSelectTeacher = React.useCallback(
    (teacherId) => {
      const normalizedTeacherId = String(teacherId || "");
      const currentIds = selectedTeacherIds.map((id) => String(id));
      const nextIds = currentIds.includes(normalizedTeacherId)
        ? currentIds.filter((id) => id !== normalizedTeacherId)
        : [...currentIds, normalizedTeacherId];
      const primingObject = {};
      Object.keys(teachersToDisplayObject).forEach((teacher) => {
        primingObject[teacher] = {
          ...teachersToDisplayObject[teacher],
          displayed: nextIds.includes(String(teachersToDisplayObject[teacher].TeacherID)),
        };
      });
      setTeachersToDisplayObject(primingObject);
      setSelectedTeacherIds(nextIds);
    },
    [teachersToDisplayObject, selectedTeacherIds]
  );

  const handleClearSelectedTeachers = React.useCallback(() => {
    unselectAllTeachers();
    setSelectedTeacherIds([]);
  }, [unselectAllTeachers]);

  const handleToggleShowExTeachers = React.useCallback(() => {
    setShowExTeachers((currentValue) => !currentValue);
  }, []);

  const createNewCalendarEvent = (e) => {
    setNewEventSaveError("");
    if (!e) {
      e = new Date(selectedDay.date);
      e.setHours(18);
    }
    setOpenEvent(true);
    setNewEvent(
      generateNewCalendarEvent(
        e,
        schoolCalendar.schoolAbbreviation.toLowerCase(),
        userData.Name,
        schoolCalendar.timeZone
      )
    );
  };

  const createNewPendingOffer = (e) => {
    if (!e) {
      e = new Date();
    }
    setOpenOffer(true);
    setNewOfferObject(
      generateNewPendingOffer(
        e,
        schoolCalendar.schoolAbbreviation.toLowerCase(),
        userData.Name
      )
    );
  };


  return (
    <div className="whole__calendar__page__wrapper">
      {loadingCover && <CalendarLoadingCover />}
      <SuccessfullySavedPopup
        show={successfullySaved}
        setShow={setSuccessfullySaved}
      />
      <ChangeFollowingEventsPopup
        open={changeFollowingEvents}
        setOpen={setChangeFollowingEvents}
        editTheEvent={editTheEvent}
        loadingCover={loadingCover}
        eventObjectToEdit={eventObjectToEdit}
        editedEventObjectsOriginalDate={editedEventObjectsOriginalDate}
      />
      <DeleteFollowingEventsPopup
        open={deleteFollowingEvents}
        setOpen={setDeleteFollowingEvents}
        deleteTheEvent={deleteTheEvent}
        eventObjectToEdit={eventObjectToEdit}
        editedEventObjectsOriginalDate={editedEventObjectsOriginalDate}
      />
      <UnsavedCalendarEventPopup
        open={discardUnsavedChangesPopup}
        setOpen={setDiscardUnsavedChangesPopup}
        discardType={discardType}
        setNewEvent={setNewEvent}
        setOpenEvent={setOpenEvent}
        setEditEventToggle={setEditEventToggle}
        setOpenOffer={setOpenOffer}
      />
      <NewCalendarEvent
        setOpenEvent={setOpenEvent}
        openEvent={openEvent}
        newEvent={newEvent}
        setNewEvent={setNewEvent}
        teachers={teachers}
        setFamilySearchOpen={setFamilySearchOpen}
        schoolCalendar={schoolCalendar}
        setSchoolFamilies={setSchoolFamilies}
        userData={userData}
        createCalendarEvent={createCalendarEvent}
        saveError={newEventSaveError}
        setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup}
        setDiscardType={setDiscardType}
      />
      <NewPendingOffer
        setOpenOffer={setOpenOffer}
        openOffer={openOffer}
        newEvent={newOfferObject}
        setNewOfferObject={setNewOfferObject}
        teachers={teachers}
        setFamilySearchOpen={setFamilySearchOpen}
        schoolCalendar={schoolCalendar}
        setSchoolFamilies={setSchoolFamilies}
        userData={userData}
        createNewPendingOffer={createNewPendingOffer}
        createCalendarEvent={createCalendarEvent}
        setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup}
        setDiscardType={setDiscardType}
      />
      <CalendarEvent
        openEvent={editEventToggle}
        setOpenEvent={setEditEventToggle}
        event={eventObjectToEdit}
        setFamilySearchOpen={setFamilySearchOpen}
        editTheEvent={editTheEvent}
        setEventObjectToEdit={setEventObjectToEdit}
        teachers={teachers}
        setChangeFollowingEvents={setChangeFollowingEvents}
        setEditedEventObjectsOriginalDate={setEditedEventObjectsOriginalDate}
        setDeleteFollowingEvents={setDeleteFollowingEvents}
        setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup}
        setDiscardType={setDiscardType}
        setEditEventToggle={setEditEventToggle}
        closeAndEditSoloEvent={closeAndEditSoloEvent}
        closeAndDeleteSoloEvent={closeAndDeleteSoloEvent}
        setOfferStatusChanged={setOfferStatusChanged}
      />
      <FamilySearchPopup
        familySearchOpen={familySearchOpen}
        setFamilySearchOpen={setFamilySearchOpen}
        schoolFamilies={schoolFamilies}
        setNewEvent={setNewEvent}
        setNewOfferObject={setNewOfferObject}
        setEventObjectToEdit={setEventObjectToEdit}
        eventObjectToEdit={eventObjectToEdit}
        openEvent={openEvent}
        openOffer={openOffer}
        school={schoolCalendar ? schoolCalendar?.schoolAbbreviation.toLowerCase() : ''}
      />
      <div className="calendar__page-shell">
        <TopBarCalendar
          schoolCalendar={schoolCalendar}
          userData={userData}
          setSchoolCalendar={setSchoolCalendar}
          createNewPendingOffer={createNewPendingOffer}
          createNewCalendarEvent={createNewCalendarEvent}
        />
        <div className="calendar__page-body">
          <TeacherListForCalendar
            teachersToDisplayObject={teachersToDisplayObject}
            setTeachersToDisplayObject={setTeachersToDisplayObject}
        loadingTeachers={loadingTeachers}
        setLoadingTeachers={setLoadingTeachers}
        unselectAllTeachers={unselectAllTeachers}
        selectedTeacherIds={selectedTeacherIds}
        onSelectTeacher={handleSelectTeacher}
        onClearSelectedTeachers={handleClearSelectedTeachers}
        showExTeachers={showExTeachers}
        onToggleShowExTeachers={handleToggleShowExTeachers}
      />
          <div className="calendar__main-panel">
            <div className="calendar__tailwind__wrapper">
              {!selectedTeacherIds.length ? (
                <div className="calendar__empty-state">
                  <div className="calendar__empty-state__title">Select one or more teachers</div>
                  <div className="calendar__empty-state__subtitle">
                    Choose teachers from the list to load and overlay their calendars.
                  </div>
                </div>
              ) : (
                <>
                  {loadingTeacherEvents && (
                    <div className="calendar__loading-overlay">
                      <div className="calendar__loading-overlay__card">
                        <div className="calendar__loading-overlay__title">Updating calendar</div>
                        <div className="calendar__loading-overlay__subtitle">
                          Loading the selected teachers&apos; schedules.
                        </div>
                        <div className="calendar__loading-overlay__skeletons">
                          <div className="calendar__loading-overlay__skeleton calendar__loading-overlay__skeleton--header" />
                          <div className="calendar__loading-overlay__skeleton-row">
                            <div className="calendar__loading-overlay__skeleton" />
                            <div className="calendar__loading-overlay__skeleton" />
                            <div className="calendar__loading-overlay__skeleton" />
                          </div>
                          <div className="calendar__loading-overlay__skeleton-row">
                            <div className="calendar__loading-overlay__skeleton" />
                            <div className="calendar__loading-overlay__skeleton" />
                            <div className="calendar__loading-overlay__skeleton" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {view === "Month view" && (
                    <MonthViewCalendar
                      setView={setView}
                      dayObject={calendarDaysWithEvents}
                      selectedDay={selectedDay}
                      setOpenEvent={setOpenEvent}
                      setNewEvent={setNewEvent}
                      schoolCalendar={schoolCalendar}
                      setSchoolCalendar={setSchoolCalendar}
                      userData={userData}
                      currentMonth={currentMonth}
                      setCurrentMonth={setCurrentMonth}
                      setEventToEdit={setEventObjectToEdit}
                      setEditEvent={setEditEventToggle}
                      createNewCalendarEvent={createNewCalendarEvent}
                      setSelectedDay={setSelectedDay}
                    />
                  )}
                  {view === "Week view" && (
                    <WeekViewCalendar
                      setView={setView}
                      calendarDaysWithEvents={calendarDaysWithEvents}
                      selectedDay={selectedDay}
                      setOpenEvent={setOpenEvent}
                      setNewEvent={setNewEvent}
                      schoolCalendar={schoolCalendar}
                      setSchoolCalendar={setSchoolCalendar}
                      userData={userData}
                      setCurrentMonth={setCurrentMonth}
                      setEventToEdit={setEventObjectToEdit}
                      setEditEvent={setEditEventToggle}
                      createNewCalendarEvent={createNewCalendarEvent}
                      setSelectedDay={setSelectedDay}
                    />
                  )}
                  {view === "Day view" && (
                    <DayViewCalendar
                      setView={setView}
                      setSelectedDay={setSelectedDay}
                      calendarDaysWithEvents={calendarDaysWithEvents}
                      selectedDay={selectedDay}
                      setOpenEvent={setOpenEvent}
                      editEventToggle={editEventToggle}
                      openOffer={openOffer}
                      newOfferObject={newOfferObject}
                      newEvent={newEvent}
                      setNewEvent={setNewEvent}
                      schoolCalendar={schoolCalendar}
                      setSchoolCalendar={setSchoolCalendar}
                      userData={userData}
                      currentMonth={currentMonth}
                      setCurrentMonth={setCurrentMonth}
                      setEventToEdit={setEventObjectToEdit}
                      setEditEvent={setEditEventToggle}
                      createNewCalendarEvent={createNewCalendarEvent}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
